import {
  delegateEvent,
  toggleBooleanDOMAttr,
  addDisposableEventListener,
} from '../core';
import { SELECTORS, CLASSES } from './constants';

function clearMenuItemState(item: Element) {
  if (item !== null) {
    item.classList.remove(CLASSES.activeClass);
    if (item.classList.contains(CLASSES.openClass)) {
      item.classList.remove(CLASSES.openClass);
      toggleBooleanDOMAttr(item, 'aria-expanded');
    }
  }
}

export class LeftNavMenu {
  private __domElements: {
    menu: Element;
  };
  private __eventDisposers: Array<() => void>;
  /**
   *
   * @param {Element} menu
   */
  constructor(menu: Element) {
    this.__domElements = { menu };
    this.__attachListeners();
  }

  destroy(): void {
    this.__domElements = null;
    this.__eventDisposers.forEach((dispose) => dispose());
  }

  private __clearActiveItems() {
    const activeItems = this.__domElements.menu.querySelectorAll(
      `.${CLASSES.activeClass}`
    );
    if (activeItems.length) {
      activeItems.forEach(clearMenuItemState);
    }
  }

  private __activateMenuItem(elem: Element) {
    this.__clearActiveItems();
    const nestedMenu = elem.closest(SELECTORS.nestedMenuAttr);
    if (nestedMenu) {
      let menuItem = elem.closest(SELECTORS.menuItemAttr);
      menuItem.classList.add(CLASSES.activeClass);
      menuItem = nestedMenu.closest(SELECTORS.menuItemAttr);
      menuItem.classList.add(CLASSES.activeClass);
      menuItem.classList.add(CLASSES.openClass);
      toggleBooleanDOMAttr(menuItem, 'aria-expanded');
    } else {
      const menuItem = elem.closest(SELECTORS.menuItemAttr);
      menuItem.classList.add(CLASSES.activeClass);
      const nestedMenu = menuItem.querySelector(SELECTORS.nestedMenuAttr);
      if (nestedMenu) {
        menuItem.classList.add(CLASSES.openClass);
        toggleBooleanDOMAttr(menuItem, 'aria-expanded');
      }
    }
  }

  private __dropdownClickHandler(elem: Element) {
    const menuItem = elem.closest(SELECTORS.menuItemAttr);
    menuItem.classList.toggle(CLASSES.openClass);
    toggleBooleanDOMAttr(menuItem, 'aria-expanded');
  }

  private __attachListeners() {
    this.__eventDisposers = [];

    this.__eventDisposers.push(
      delegateEvent(
        this.__domElements.menu,
        'click',
        SELECTORS.itemLinkAttr,
        this.__activateMenuItem.bind(this)
      )
    );

    this.__eventDisposers.push(
      delegateEvent(
        this.__domElements.menu,
        'click',
        SELECTORS.dropdownAttr,
        this.__dropdownClickHandler.bind(this)
      )
    );

    this.__eventDisposers.push(
      addDisposableEventListener(
        this.__domElements.menu,
        'scroll',
        function (event) {
          const menu = event.target as Element;
          menu.classList.add(CLASSES.scrollingClass);
          setTimeout(function () {
            const isScrolledToBottom =
              menu.scrollHeight - menu.clientHeight <= menu.scrollTop + 1;
            const isScrolledToTop = menu.scrollTop == 0;
            if (isScrolledToTop || isScrolledToBottom) {
              menu.classList.remove(CLASSES.scrollingClass);
            }
          }, 600); // todo: why 600? (magical number)
        }
      )
    );
  }
}
